<script>
  import { createEventDispatcher, onDestroy, onMount } from 'svelte';
  import { slidesTracker, slidesGo } from '../../../stores';
  import Photos from '../../Photos.svelte';
  import { __,__c } from '../../../utils/i18n';
 
  export let topHed;
  export let slides;
  export let level; 
  
  // trigger component to show up and go away
  const dispatch = createEventDispatcher();
  function toggleShow() { dispatch('show') }

  // stop home page from scrolling
	function stopScroll() { window.document.body.classList.add('stop-scroll'); }
  function restartScroll() { window.document.body.classList.remove('stop-scroll');}

  // slide interaction and keyboard navigation
  let contactPoint;

  const ARROW_LEFT = 37;
	const ARROW_RIGHT = 39;
	function handleShortcut(e) {
    if (e.keyCode === ARROW_LEFT ) {
      prev();
    }
    if (e.keyCode === ARROW_RIGHT ) {
      next();
    }
    if (e.key == 'Escape') {
      toggleShow();
    }
	}

	const clamp = (number, min, max) => Math.min(Math.max(number, min), max);

	function prev() {
		$slidesTracker[level] = clamp( --$slidesTracker[level], 0, slides.length-1 ); 
    
    if (slideTimer) slideTimer.reset();
	}
	
	function next() {
		$slidesTracker[level] = clamp( ++$slidesTracker[level], 0, slides.length );

		if ($slidesTracker[level] == slides.length){
			$slidesTracker[level]=0
			toggleShow();
		}

    if (slideTimer) slideTimer.reset();
	}


  function handleSlides(direction) {
    if (direction == "next") {
      next();
    } else if (direction == "prev") {
      prev();
    }
  }

  // progress bar
  let slideTimer, pauseTimer, rememberGesture = false, threshold = 400; 
  let hold = false;
  const slideDuration = 4000; 
  // if this value is changed, pls change the corresponding css animation to match in slides.scss

  function Timer(callback, delay) {
    var timerId, start, leftOff = delay, remaining = delay;

    this.pause = function() {
      window.clearTimeout(timerId);
      remaining -= Date.now() - start; 
      // console.log(remaining);
    };

    this.resume = function() {
      start = Date.now(); 
      window.clearTimeout(timerId);
      timerId = window.setTimeout(callback, remaining)
      // console.log(start, remaining);
    };

    this.clear = function() {
      window.clearTimeout(timerId);
    };

    this.reset = function() {
      start = Date.now();
      window.clearTimeout(timerId);
      remaining = leftOff;
      timerId = window.setTimeout(callback, remaining);
    };

    this.resume();
    // console.log('timer was initialized');
  }

  function startGesture(e) {
    if (slideTimer) slideTimer.pause();
    hold = true; 
    rememberGesture = true;

    //grab the point where the mouse or the finger is touching on the screen
    e.type == "touchstart"
      ? ( contactPoint = e.changedTouches[0].pageX )
      : ( contactPoint = e.pageX )

    pauseTimer = setTimeout(() => {
      rememberGesture = false;
    }, threshold)
  }

  function releaseGesture(e) {
    if (rememberGesture) {
      contactPoint > window.innerWidth / 2
        ? handleSlides("next")
        : handleSlides("prev");
    } else {
      // console.log("stay where you are");
    }


    if (pauseTimer) clearTimeout(pauseTimer);
    if (slideTimer) slideTimer.resume();
    hold = false; 

    contactPoint = 0;
  } 

  function changeSlide(slide) {
		$slidesTracker[level] = slide;
	}
  let isMobile = window.matchMedia('(hover:none)').matches;

  onMount(() => {
    stopScroll()
    
    if (isMobile) {
      slideTimer = new Timer(() => {
        handleSlides("next");
        }, slideDuration);
    }
  });

  onDestroy(() => {
    restartScroll()

    if (slideTimer) {
      slideTimer.clear();
      slideTimer = null;
    }
  });

const bg = {
  "city" : "#efffed",
  "county": "#FFF5D1",
  "state": "#EAF7FF",
};

let check = (s) => {
  return (s.match(/<p>/g) || []).length
};

// let splitUp = (s) => {
//   let splitResult = s.replace("</p>", "</p>,").split(",");
//   return splitResult
// }

let splitUp = (s) => {
  let splitResult = s.replace("</p>", "</p>^").split("^");
  return splitResult
}

// let splitUp = (s) => {
//   let splitTag = s.replace("</p>", "</p>,");
//   if () {
//     splitTag.split(",");
//   }
  
//   .split(",");
//   return splitResult
// }

</script>

<svelte:window on:keyup={handleShortcut} />

<div class="extra-outer-wrapper">
  <div 
		class="close" 
    role="button" 
		tabindex="0"
    aria-label="{__('Select button to close slideshow.')}"
    on:click={toggleShow} 
    on:keypress={(e)=>{if (e.key == "Enter") toggleShow() }}
    >
			<span>{topHed}</span>  
			<svg class="icon icon-close" aria-label="{__('Close slideshow')}">
				<use xlink:href="#icon-close" />
			</svg>
	</div>
  <div class="bars">
		{#each slides as slide, i}
      {#if $slidesGo && $slidesTracker[level] == i}
        <div class="bar">
          <div id="progress" class={hold ? 'pause': ''}></div>
        </div>
      {/if} 
        <button 
          on:click={()=>changeSlide(i)} class="bar" 
          class:selected={$slidesTracker[level] == i} 
          class:viewed={$slidesTracker[level] > i}
          >{i+1}</button>
		{/each}
	</div> 
  <div 
    class="outer-wrapper" 
    style="background:white"

    on:mousedown={e => {
      startGesture(e);
    }}
    on:touchstart|preventDefault={e => {
      startGesture(e);
    }}
    on:mouseup={e => {
      if (hold) releaseGesture(e);
    }}
    on:touchend|preventDefault={e => {
      if (hold) releaseGesture(e);
    }}
  
  >
    <div class="inner-wrapper">
      {#each slides as slide, id}
        {#if id === $slidesTracker[level]}
          <div 
            style="background:{bg[level]}" 
            class="slide {level}">		
            <div class="slide-copy">
              {@html splitUp(slide[`${__c('content')}_html`])[0]}
            </div>
            {#if slide.img}
              <Photos lookup='{slide.img}' className = "" idName = "" ariaHidden = "false" lazyLoad = "true"/>
            {/if}
            {#if slide.bg_img}
              <Photos lookup='{slide.bg_img}' className = "{slide.bg_class}" idName = "{slide.bg_id}" ariaHidden = "true" lazyLoad = "true"/>
            {/if}
            <div class="slide-copy">
              {#if check(slide.content_html) > 1}
                {@html splitUp(slide[`${__c('content')}_html`])[1]}
              {/if}
            </div>
          </div>
          <div class="controls">
            <!-- <button on:click="{()=>prev()}" class="{ id===0? 'off':''}"> -->
            <button class="{ id===0? 'off':''}">
              <span class="hide-on-mobile">&larr;</span>
            </button>
            <!-- <button on:click="{()=>next()}" class="{ id===(slides.length-1)? 'offend':''}"> -->
            <button class="{ id===(slides.length-1)? 'offend':''}">
              <span class="hide-on-mobile">&rarr;</span>
            </button>
          </div>
          <div class="slide-number hide-on-mobile">
            <span>{id + 1}/{slides.length}</span>
          </div>
        {/if}
      {/each}
    </div>
  </div> 
</div>

